import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const QuickDialListItemParts = [
  'container',
  'textContainer',
  'labelContainer',
  'labelText',
  'subLabelText',
  'buttonsContainer',
] as const

const helpers = createMultiStyleConfigHelpers(QuickDialListItemParts)
export const QuickDialListItemStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      flexShrink: 0,
      justifyContent: 'flex-start',
      alignItems: 'center',
      height: '3.75rem',
      width: 'full',
      paddingX: '0.75rem',
      gap: '0.75rem',
      borderRadius: '0.5rem',
      _hover: {
        backgroundColor: 'gray.300',
        '& > div.action-buttons': {
          display: 'flex',
        },
      },
    },
    textContainer: {
      flexDirection: 'column',
      justifyContent: 'center',
      gap: '0.25rem',
    },
    labelContainer: {
      alignItems: 'center',
      gap: '0.5rem',
    },
    labelText: {
      textStyle: textStyleKeys.Body1,
    },
    subLabelText: {
      textStyle: textStyleKeys.Body3,
    },
    buttonsContainer: {
      display: 'none',
      gap: '0.25rem',
    },
  },
})

export const useQuickDialListItemStyle = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof QuickDialListItemParts>(
    getName({ QuickDialListItemStyle }),
    props,
  )
}
